/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The NoteResponse model module.
* @module model/NoteResponse
* @version 2020-12-7
*/
export default class NoteResponse {
    /**
    * Constructs a new <code>NoteResponse</code>.
    * 通知
    * @alias module:model/NoteResponse
    * @class
    * @param timestamp {Number} 発生時刻
    * @param userId {Number} ユーザーID
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(timestamp, userId, updatedAt) {
        
        
        this['timestamp'] = timestamp;
        this['userId'] = userId;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>NoteResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/NoteResponse} obj Optional instance to populate.
    * @return {module:model/NoteResponse} The populated <code>NoteResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NoteResponse();
                        
            
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 発生時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * ユーザーID
    * @member {Number} userId
    */
    'userId' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
